import { watch } from "vue"

export function useDebounceWatch( source, callback, delay = 800, options = {} ) {
    let timeout

    watch(source, (newVal, oldVal, onCleanup) => {
        if (timeout) clearTimeout(timeout)

        timeout = setTimeout(() => {
            callback(newVal, oldVal)
        }, delay)

        onCleanup(() => {
            clearTimeout(timeout)
        })
    }, options)
}

/**
 *  HOW TO USE
 *  
 *  1. Importer le composable comme n'importe quel composant vue
 *  2. Au lieu d'utiliser watch() on utilise useDebounceWatch()
 *      2.1. Par défaut, le debounce est de 800ms, mais on peut lui préciser en params.
 *  
 *  EXAMPLE:
 *  
 *  useDebounceWatch(searchInput, (newVal) => {
 * 
 *       console.log(searchInput.value)
 * 
 *  }, 800) // On n'est pas obligés de lui préciser 800ms car c'est la valuer par défaut. Cette valeur est modifiable.
 */